import { Box, IconButton, Typography } from '@material-ui/core'
import styled from 'styled-components'
import { Button } from 'common/atoms/Button/Button'

export const ReportedContentDetail = styled(Box)`
  && {
    box-sizing: border-box;
    background-color: ${({ theme }) => theme.colors.supplementary};
    padding: 3em 2em;
    border-radius: 1em;
    margin: 6em 2em;
    box-shadow: 0px 24px 38px rgba(0, 0, 0, 0.14), 0px 9px 46px rgba(0, 0, 0, 0.12), 0px 11px 15px rgba(0, 0, 0, 0.2);
  }
`

export const ReportedContentButton = styled(Box)`
  && {
    display: inline-block;
    color: ${({ theme }) => theme.colors.accent};
    border-radius: 4em;
    cursor: pointer;
  }
`

export const ReportedContentStyledButton = styled(Button)`
  && {
    border-radius: 0.5em;
    width: 300%;
    font-weight: 900;
    font-size: .8rem;
  }
`
export const StyledImage = styled.img`
  display: block;
  margin-top: 0.3em;
  width: 100%;
  height: 200px;
`
export const StyledReportContentIconButton = styled(IconButton)`
  && {
    border-radius: 0;
    width: 100%;
    color: ${props => props.theme.colors.accent1};
    padding: 0;

    .MuiTypography-root {
      line-height: 1em;
      font-weight: bold;
      font-size: 0.75rem;
      padding: 10px;
    }
    &:disabled {
      background-color: ${({ theme }) => theme.colors.bgPrimary};
      color: none
    }
  }
`

export const UnblockAndSuspendStyledButton = styled(Button)`
  && {
    margin-top: 2rem;
    margin-left: auto;
    border-radius: 0.5em;
    font-weight: 900;
    width: 8rem;
  }
`

export const ReportModalSubheading = styled(Typography)`
  display: block;
  color: ${props => props.theme.colors.accent1};
  font-size: 0.875rem;
  padding: .8rem 0 0;
`